import { FrontTable } from '@/lib';
import { FC, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getFileElementsTableColumns } from './helpers';
import { DataSourceFileConfig, TDataSource } from '@/models/dataSource';

type FileElementsTableProps = {
  fileContent: string[][];
  isDefaultHeaderCorrect: boolean;
  dataSource?: TDataSource<DataSourceFileConfig>;
};
export const FileElementsTable: FC<FileElementsTableProps> = ({ dataSource, fileContent, isDefaultHeaderCorrect }) => {
  const { t } = useTranslation();
  const [tableContent, setTableContent] = useState<string[][]>([]);
  const headers = dataSource?.configuration.headers || [];

  useEffect(() => {
    if (fileContent) {
      if (isDefaultHeaderCorrect) {
        setTableContent(fileContent.filter((_, i) => i > 0));
      } else {
        setTableContent(fileContent.filter((_, i) => i >= 0));
      }
    }
  }, [fileContent, isDefaultHeaderCorrect]);

  const tableData = useMemo(() => {
    return tableContent.map((row) => {
      const rowObject: Record<string, any> = {};
      row.forEach((cell, index) => {
        rowObject[`col_${index}`] = cell;
      });
      return rowObject;
    });
  }, [tableContent]);

  const columns = useMemo(() => {
    if (!headers.length || !fileContent.length) return [];

    return getFileElementsTableColumns({
      t,
      headers,
      fileContent,
      isDefaultHeaderCorrect,
    });
  }, [t, headers, fileContent, isDefaultHeaderCorrect]);

  return <FrontTable innerWrapperClassName='pb-0' tableData={tableData} columns={columns} notFound={t('ALL:data_sources.fileEmpty')} />;
};
